import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './library/fontawesome 5.10.1/css/all.min.css'
import App from './App';
import * as serviceWorker from './serviceWorker';

// redux
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import RootReducer from './redux/reducers'

if("localhost:3000"!==window.location.host) {
    if (!window.location.host.startsWith("www")){
        window.location = window.location.protocol + "//www." + window.location.host + window.location.pathname
    }
}

const store = createStore(RootReducer)

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>, 
    document.getElementById('appRoot')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();